import { app } from '../../../../../../../bootstrap/core';

import { confirmWarrantHeadingComponent } from './heading.component';

app.component(
  confirmWarrantHeadingComponent.name,
  confirmWarrantHeadingComponent,
);
